import config from './config'
import {
  isFunction,
  isUndefined
} from './utils'

/**
 * Rewrite web page title.
 * @param title
 */
function pageTitle (title: string): void {
  const _t: string = config.WEB_TITLE

  document.title = Boolean(title)
    ? `${title} - ${_t}`
    : _t
}

/**
 * Rewrite document overflow style.
 * @param value 
 */
function pageOverflow (value: string): void {
  if (isUndefined(value)) {
    throw new Error('Parameter [1] is undefined!')
  }
  
  document.body.style.overflow = value
  document.getElementsByTagName('html')[0].style.overflow = value
}

/**
 * Random UniqueKey Values.
 * @return string
 */
function uniqueKey (): string {
  return (`${1e3}-${1e3}-${4e3}-${1e5}`).replace(/[018]/g, (c: any) =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
}

/**
 * Delay after then.
 * @param callback only function
 * @param time 
 */
function delay (callback: any, time: number) {
  setTimeout(() => {
    if (!isFunction(callback)) {
      throw new Error('Parameter [1] is not a Function!')
    }
    callback()
  }, time * 1000)
}

/**
 * Truncate limitor text.
 * @param str string
 * @param limit number
 */
function truncate (str: string, limit: number): string {
  if (str.length <= limit) return str

  const bake: string  = '...'
  let x: string = str.substr(0, limit)
  let n: number = str.lastIndexOf(' ')

  if (n > -1) x = str.substr(0, n)

  return `${x}${bake}`
}

/**
 * AddEventListener onTouch in TargetElNode.
 * @param element any
 * @param callback function
 */
function touch (element: any, callback: any): void {
  let use: boolean = false
  let X: number = 0
  let Y: number = 0
  let data: any = null
  let startNode: any = null

  if (element) {
    element.addEventListener('touchstart', touchStart, false)
    element.addEventListener('touchmove', touchMove, false)
    element.addEventListener('touchend', touchEnd, false)
  } else {
    element.removeEventListener('touchstart', touchStart, false)
    element.removeEventListener('touchmove', touchMove, false)
    element.removeEventListener('touchend', touchEnd, false)
  }

  function touchStart (event: any): void {
    const { pageX, pageY, clientX, clientY }: any = event.changedTouches[0]
      X = pageX || clientX
      Y = pageY || clientY
      use = false
      startNode = event.target
  }

  function touchMove (event: any): void {
    const { pageX, pageY, clientX, clientY }: any = event.changedTouches[0]
    const $x: number = pageX || clientX
    const $y: number = pageY || clientY
    const r: number = 20

    let touchX, touchY
    if ($y + r <= Y) touchY = 'up';
    if ($y - r >= Y) touchY = 'down';
    if ($x + r <= X) touchX = 'left';
    if ($x - r >= X) touchX = 'right';

    if (touchX || touchY) {
      use = true
      data = { x: touchX, y: touchY }
    }
  }

  function touchEnd (event: any): void {
    if (!data) use = false;
    if (use && isFunction(callback)) {
      callback({
        data,
        startNode,
        endNode: event.target
      })
    }
  }
}

/**
 * Query closest NodeTarget.
 * @param element any
 * @param selector string
 */
function closest (element: any, selector: string): any {
  // Get the closest matching element
  for (; element && element !== document; element = element.parentNode) {
    console.log(element, selector);
    
    if (element.matches(selector)) {
      return true
    }
  }

  return false
}

/**
 * Convert to Integer.
 * @param val
 */
function number (val: any): number {
  return val.toString() * 1
}

/**
 * Convert to Price.
 * @param val value
 * @param fix delimiters
 */
function pricer (val: any, fix: number): string {
  const n: string = Number(val).toFixed(fix || 0).toString()
  return n.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

/**
 * Disable browser back.
 * @param use #EventListener
 */
function stopBack (use: boolean): void {
  history.pushState(null, '', location.href)
  const f = () => { history.go(1) }

  if (!use) {
    window.addEventListener('popstate', f)
  } else {
    window.removeEventListener('popstate', f)
  }
}

/**
 * Hightlight.
 * 
 * @param {string} str
 * @param {string} search
 */
function Hightlight (str: string, search: string): string {
  const reGex: any  = new RegExp(search, 'gi')
  const hls: string = String(str).replace(reGex,
    (match: string): string => `<span id=hls>${match}</span>`)

    return search ? hls : str
}

/**
 * Cloner
 * 
 * @param {Object|Array} input
 */
function cloner (input: any): any {
  return JSON.parse( JSON.stringify( input ) )
}

/**
 * Events loading component.
 * 
 * @param {boolean} val
 */
function Load (vnode: any, val: boolean): void {
  vnode.$store.dispatch('APP.DEMO/L04D', val)
}

export {
  number as n,
  pricer,
  touch,
  Load,
  delay,
  cloner,
  closest,
  stopBack,
  stopBack as s,
  Hightlight,
  Hightlight as hls,
  truncate,
  uniqueKey,
  pageTitle as title,
  pageOverflow as overflow
}